module.exports = __webpack_public_path__ + "static/media/image08.e39702c8.png";